import { Popconfirm, Tooltip, Typography } from "antd";
import { DeleteOutlined, EditOutlined, LockOutlined } from "@ant-design/icons";
const { Text } = Typography;

export const STATUS_MANAGEMENT_COLUMNS_HEAD = (
  confirmDelete,
  editStatusFun,
) => {
  return [
    {
      title: "Serial No.",
      dataIndex: "serial_no",
      align: "left",
    },
    {
      title: "Status Name",
      dataIndex: "",
      align: "left",
      render: (ele) => {
        return (
          <Text style={{ wordBreak: "break-word" }}>
            {ele.name} {ele.is_protected && <span className="protected-status"><LockOutlined />Protected</span>}
          </Text>
        );
      },
    },
    {
      title: "Actions",
      dataIndex: "",
      align: "right",
      width: "200px",
      render: (ele) => {
        return ele.is_protected ? null : (
          <div>
            <Tooltip title="Edit Status" color="#11b052">
              <EditOutlined
                style={{
                  backgroundColor: "#0eff7742",
                  color: "#11b052",
                  borderRadius: "3px",
                  padding: "6px",
                  fontSize: "16px",
                  cursor: "pointer",
                  marginRight: "15px",
                }}
                onClick={() => editStatusFun(ele)}
              />
            </Tooltip>
            <Tooltip title="Delete Status" color="#F84646">
              <Popconfirm
                placement="bottomRight"
                title="Delete the Status"
                description="Are you sure You want to delete this Status?"
                onConfirm={() => confirmDelete(ele)}
                okText="Yes"
                cancelText="No"
              >
                <DeleteOutlined
                  style={{
                    backgroundColor: "rgba(248, 70, 70, 0.15)",
                    color: "#F84646",
                    borderRadius: "3px",
                    padding: "6px",
                    fontSize: "16px",
                    cursor: "pointer",
                  }}
                />
              </Popconfirm>
            </Tooltip>
          </div>
        );
      },
    },
  ];
};

export const ADD_STATUS_INITIAL_OBJECT = {
  name: "",
  errorFieds: {
    name: "",
  },
};
